export const CDI_FOUNDATION = Object.freeze({ year: 2000, month: 10, day: 26 });
export const CDI_TIME_ZONE = 'America/Sao_Paulo';
export const CDI_AGE_VARIABLE = '{{idade_cdi}}';

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: CDI_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
});

function zonedDateParts(value) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) throw new RangeError('A data informada para calcular a idade da CDI é inválida.');

  return Object.fromEntries(
    dateFormatter.formatToParts(date)
      .filter(part => part.type !== 'literal')
      .map(part => [part.type, Number(part.value)]),
  );
}

export function getCdiAge(at = new Date()) {
  const { year, month, day } = zonedDateParts(at);
  const anniversaryHasPassed = month > CDI_FOUNDATION.month
    || (month === CDI_FOUNDATION.month && day >= CDI_FOUNDATION.day);
  return year - CDI_FOUNDATION.year - (anniversaryHasPassed ? 0 : 1);
}

function localDateTimeToUtc({ year, month, day, hour = 0, minute = 0, second = 0 }) {
  const desiredAsUtc = Date.UTC(year, month - 1, day, hour, minute, second);
  let instant = desiredAsUtc;
  for (let attempt = 0; attempt < 3; attempt += 1) {
    const zoned = zonedDateParts(new Date(instant));
    const renderedAsUtc = Date.UTC(
      zoned.year, zoned.month - 1, zoned.day, zoned.hour, zoned.minute, zoned.second,
    );
    instant += desiredAsUtc - renderedAsUtc;
  }
  return instant;
}

export function millisecondsUntilNextCdiAgeChange(at = new Date()) {
  const date = at instanceof Date ? at : new Date(at);
  const { year, month, day } = zonedDateParts(date);
  const beforeAnniversary = month < CDI_FOUNDATION.month
    || (month === CDI_FOUNDATION.month && day < CDI_FOUNDATION.day);
  const anniversaryYear = beforeAnniversary ? year : year + 1;
  const nextChange = localDateTimeToUtc({
    year: anniversaryYear,
    month: CDI_FOUNDATION.month,
    day: CDI_FOUNDATION.day,
  });
  return Math.max(0, nextChange - date.getTime());
}

export function interpolateCdiAge(value, at = new Date()) {
  if (typeof value === 'string') {
    return value.replaceAll(CDI_AGE_VARIABLE, String(getCdiAge(at)));
  }
  if (Array.isArray(value)) return value.map(item => interpolateCdiAge(item, at));
  if (value && typeof value === 'object' && (Object.getPrototypeOf(value) === Object.prototype || Object.getPrototypeOf(value) === null)) {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, interpolateCdiAge(item, at)]));
  }
  return value;
}
